







































import { defineComponent } from "@vue/composition-api"
import { useGetters, useState } from "vuex-composition-helpers"

import ContentComponent from "../shared/ContentComponent.vue"
import CrumbsComponent from "../shared/CrumbsComponent.vue"
import ImageComponent from "../shared/ImageComponent.vue"
import IntroComponent from "../shared/IntroComponent.vue"
import NavigationComponent from "../shared/NavigationComponent.vue"
import VideoComponent from "../shared/VideoComponent.vue"

export default defineComponent({
    name: "HeroSlider",
    components: {
        ContentComponent,
        CrumbsComponent,
        ImageComponent,
        IntroComponent,
        NavigationComponent,
        VideoComponent
    },
    setup: () => {
        const { transition, videoIsPlaying} = useState(['transition', 'videoIsPlaying'])
        const { singleSlide, shouldShowLink, assetComponent, assetContent } = useGetters(['singleSlide', 'shouldShowLink', 'assetComponent', 'assetContent'])
        
        return {
            assetComponent,
            assetContent,
            shouldShowLink,
            singleSlide,
            transition,
            videoIsPlaying
        }
    }
})
